<template>
  <div id="app">
    <MainScreen />
  </div>
</template>

<script>
import MainScreen from './components/MainScreen.vue'

export default {
  name: 'App',
  mounted() {
    window.parent.postMessage('game_ready', '*')
  },
  components: {
    MainScreen,
  },
}
</script>

<style>
html,
body {
  margin: 0;
}

* {
  box-sizing: border-box;
}

#app {
  position: absolute;
  inset: 0px;
  font-family: 'Inter Black';
  color: #666666;
}
</style>
